// Interpreta o texto do Comprovante de Inscrição e de Situação Cadastral da
// Receita Federal (o que o usuário copia da página com Ctrl+A / Ctrl+C) e
// devolve os campos já no formato do formulário de cliente.

const LABEL_NUMERO_INSCRICAO = "NÚMERO DE INSCRIÇÃO";
const LABEL_NOME_EMPRESARIAL = "NOME EMPRESARIAL";

// Os rótulos são comparados por igualdade exata: buscar por substring quebra o
// parser porque valores contêm rótulos (ex.: "TRANSPORTES" contém "PORTE").
const LABELS = {
  [LABEL_NUMERO_INSCRICAO]: "cnpj",
  [LABEL_NOME_EMPRESARIAL]: "NOMECLI",
  "TÍTULO DO ESTABELECIMENTO (NOME DE FANTASIA)": "NOMEFANTASIA",
  LOGRADOURO: "ENDCLI",
  NÚMERO: "NUMERO",
  COMPLEMENTO: "COMPLEMENTO",
  CEP: "CEPCLI",
  "BAIRRO/DISTRITO": "BAIRROCLI",
  MUNICÍPIO: "CIDADECLI",
  UF: "ESTADOCLI",
  "ENDEREÇO ELETRÔNICO": "E_MAIL",
  TELEFONE: "telefone",
  "SITUAÇÃO CADASTRAL": "situacaoCadastral",
};

const onlyDigits = (value) => (value || "").replace(/\D/g, "");

const isEmptyValue = (value) => !value || /^\*{3,}$/.test(value);

// As células da tabela do comprovante vêm separadas por tab quando copiadas;
// achatar em linhas deixa a varredura rótulo → valor uniforme.
const toLines = (rawText) =>
  String(rawText)
    .replace(/\t/g, "\n")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

const normalizeLabel = (line) => line.toUpperCase().replace(/\s+/g, " ").trim();

const isLabel = (line) =>
  Object.prototype.hasOwnProperty.call(LABELS, normalizeLabel(line));

export const looksLikeReceitaComprovante = (rawText) => {
  if (!rawText) return false;
  const labels = toLines(rawText).filter(isLabel).map(normalizeLabel);
  return (
    labels.includes(LABEL_NUMERO_INSCRICAO) &&
    labels.includes(LABEL_NOME_EMPRESARIAL)
  );
};

const parseTelefone = (value, fields) => {
  const numeros = value
    .split("/")
    .map(onlyDigits)
    .filter((numero) => numero.length >= 10 && numero.length <= 11);

  if (numeros[0]) {
    fields.DDDCLI = numeros[0].substring(0, 2);
    fields.FONECLI = numeros[0].substring(2);
  }
  if (numeros[1]) {
    fields.DDDCELULAR = numeros[1].substring(0, 2);
    fields.CELULAR = numeros[1].substring(2);
  }
};

export const parseReceitaCnpj = (rawText) => {
  if (!looksLikeReceitaComprovante(rawText)) return null;

  const lines = toLines(rawText);
  const fields = {};
  const meta = { cnpj: "", situacaoCadastral: "" };

  lines.forEach((line, index) => {
    if (!isLabel(line)) return;

    const label = normalizeLabel(line);
    const key = LABELS[label];
    const value = lines[index + 1];

    // Célula vazia na tabela: o próximo conteúdo já é outro rótulo.
    if (value === undefined || isLabel(value) || isEmptyValue(value)) return;

    switch (key) {
      case "cnpj": {
        const digits = onlyDigits(value);
        if (digits.length === 14 && !meta.cnpj) {
          meta.cnpj = digits;
          fields.CGCCLI = digits;
        }
        break;
      }
      case "situacaoCadastral":
        if (!meta.situacaoCadastral) {
          meta.situacaoCadastral = normalizeLabel(value);
        }
        break;
      case "telefone":
        if (!fields.FONECLI) parseTelefone(value, fields);
        break;
      case "CEPCLI":
        if (!fields.CEPCLI) fields.CEPCLI = onlyDigits(value);
        break;
      case "E_MAIL":
        if (!fields.E_MAIL) fields.E_MAIL = value.toLowerCase();
        break;
      case "ESTADOCLI":
        if (!fields.ESTADOCLI && /^[A-Za-z]{2}$/.test(value)) {
          fields.ESTADOCLI = value.toUpperCase();
        }
        break;
      default:
        if (!fields[key]) fields[key] = value;
    }
  });

  return { fields, meta };
};
